import React, { useState } from 'react'

import XText from 'v2/components//XText'
import XButton from 'v2/components/XButton'
import { BUTTON_STYLE_TYPE, XTEXT_DECORATIONS, XTEXT_SIZE, XTEXT_TYPE } from 'v2/styles/constants'
import AlertSvg from '@svgs/alert.svg'
import InfoSvg from '@svgs/info.svg'
import c from 'clsx'
import styles from './style.module.scss'
import XColors from 'v2/styles/colors'
import { Icon } from '@material-ui/core'
import { isMobile } from 'react-device-detect'

interface Props {
    title: string
    description: string
    buttonTitle: string
    buttonAction: any
    isButton?: boolean
    isCloseButton?: boolean
    isButtonDisabled: boolean
    type: string
    isLongBeachV2Design?: boolean
}

const iconComponents = {
    warning: <AlertSvg />,
    info: <InfoSvg />,
}

const XBanner = (props) => {
    const {
        title,
        description,
        buttonTitle,
        buttonAction,
        isButton = true,
        isCloseButton = false,
        isButtonDisabled,
        isLongBeachV2Design,
        type,
    } = props
    const iconComponent = iconComponents[type] || null

    const [isDisplayed, setIsDisplayed] = useState(true)

    return (
        isDisplayed && (
            <div className={c(styles.xBanner__container, styles[type])}>
                <div className={c(styles.xBanner__container__title_group, styles[type])}>
                    <div className={c(styles.xBanner__container__title_group__icon, styles[type])}>{iconComponent}</div>
                    <div className={styles.xBanner__container__group}>
                        <div className={c(styles.xBanner__container__title_group__title, styles[type])}>
                            <XText
                                wrapText={true}
                                type={XTEXT_TYPE.INPUT}
                                color={XColors.backgroundColor}
                                size={XTEXT_SIZE.MEDIUM_BIGGER}
                                decorator={XTEXT_DECORATIONS.BOLD}
                            >
                                {title}
                            </XText>
                        </div>
                        {isMobile && isCloseButton && (
                            <div
                                className={styles.xBanner__container__title_group__close_button}
                                onClick={() => {
                                    setIsDisplayed(false)
                                }}
                            >
                                <Icon style={{ verticalAlign: 'middle', marginRight: '10px' }}>{'close'}</Icon>
                            </div>
                        )}
                    </div>
                </div>
                <div className={c(styles.xBanner__container__description, styles[type])}>
                    <XText color={XColors.darkGray} size={XTEXT_SIZE.MEDIUM} decorator={XTEXT_DECORATIONS.REGULAR}>
                        {description}
                    </XText>
                </div>
                <div className={styles.xBanner__container__button}>
                    {isButton && (
                        <XButton
                            styleType={
                                isLongBeachV2Design
                                    ? BUTTON_STYLE_TYPE.LB_BUTTON_V2
                                    : isButtonDisabled
                                    ? BUTTON_STYLE_TYPE[`${type.toUpperCase()}_DISABLED`]
                                    : BUTTON_STYLE_TYPE[type.toUpperCase()]
                            }
                            onClick={buttonAction}
                            disabled={isButtonDisabled}
                        >
                            {buttonTitle}
                        </XButton>
                    )}
                </div>
                {!isMobile && isCloseButton && (
                    <div
                        className={styles.xBanner__container__close_button}
                        onClick={() => {
                            setIsDisplayed(false)
                        }}
                    >
                        <Icon style={{ verticalAlign: 'middle', marginRight: '10px' }}>{'close'}</Icon>
                    </div>
                )}
            </div>
        )
    )
}

export default XBanner
